export default __webpack_public_path__ + "static/media/jp-icon.2e2e9e05.svg";